// Normal case: Load deferred after window.load() event.
window.addEventListener('load', function(e) {
    //console.log('Ad Wrapper: Window load event.');
    if (!window.prebidAuctionRun) {
        //console.log('Ad Wrapper: Running Prebid auction on load event...');
        window.prebidAuctionRun = true;
        clearTimeout(window.adsLoadTimer);
        runWrapper();
    }
});

// If it's taking too long, go ahead and load deferred before window.load() event occurs.
document.addEventListener('DOMContentLoaded', function(e) {
    //console.log('Ad Wrapper: Document ready event.');
    window.adsLoadTimer = setTimeout(function() {
        if (!window.prebidAuctionRun) {
            //console.warn('Ad Wrapper: Running Prebid auction due to timeout...');
            window.prebidAuctionRun = true;
            runWrapper();
        }
    }, 2000);
});

// Reference to the global command queue for asynchronous execution of GPT-related calls.
var googletag = googletag || {};
googletag.cmd = googletag.cmd || [];

// Reference to the global command queue for asynchronous execution of Prebid-related calls.
var pbjs = pbjs || {};
pbjs.que = pbjs.que || [];

// =============================================================================
// TCF CMP WATCHDOG
// =============================================================================
//
// Background: a consentmanager.net CMP is embedded in this site's templates.
// When its remote configuration fails to load, the CMP answers every TCF query
// with cmpStatus "loading" forever: no banner is rendered, no consent string
// is ever produced, and gdprApplies stays true. GPT and Prebid are both
// consent-aware, so in that state neither of them sends a single ad request
// and every slot on the site goes dark. This happened for real on 03.09.2026
// and cost a full ad outage.
//
// What the failure actually looks like (measured 04.09.2026): the CMP core
// script loads and its first configuration call (/delivery/cmp.php) completes
// normally, but the answer carries no configuration -- the account's designs
// are all geo-targeted and none is marked as fallback, so a visitor whose
// country matches no design gets nothing. On a healthy load the design file
// (/delivery/customdata/...) is requested within a few milliseconds of
// cmp.php finishing; on the broken load nothing ever follows cmp.php.
//
// What this watchdog does:
//
//   1. It wraps window.__tcfapi in a transparent pass-through proxy. While
//      the CMP behaves normally, the proxy changes nothing: every call and
//      every event goes straight through, and consent behavior is entirely
//      the CMP's.
//
//   2. It watches the CMP's own network activity (the design-file <script>
//      element in the DOM, and the browser's resource timeline). If cmp.php
//      has completed and no design file has been requested for
//      CMP_NO_DESIGN_CONFIRM_MILLISECONDS afterwards, the
//      CMP is in the broken state described above and the watchdog takes
//      over. This is a positive detection of the failure, not a timeout, so
//      it fires early (about 2 seconds into the page) for a broken visitor and
//      NEVER fires for a visitor whose CMP is merely slow but progressing.
//
//   3. A visitor for whom the CMP IS progressing (design file requested, or
//      the CMP's own status advanced, or a real "cmpuishown" / "tcloaded"
//      event arrived) is left entirely to the real CMP. That includes EU
//      visitors, who must see the banner and whose ads must wait for their
//      choice. The watchdog stands down for good on any such signal.
//
//   4. As a last resort, if the CMP shows no progress at all for
//      CMP_WATCHDOG_MAX_WAIT_MILLISECONDS (its scripts never loaded, the
//      vendor is entirely unreachable), the watchdog also takes over, so a
//      genuine vendor outage still cannot black out the site for the
//      non-EEA audience.
//
//   5. Before taking over it checks the visitor's device timezone. A device
//      set to an unambiguously EEA/CH/UK timezone (Berlin, Vienna, Zurich,
//      Paris, ...) is never answered synthetically: for that visitor the
//      watchdog does nothing, and if the CMP cannot serve them they get no
//      ads rather than ads without consent. Timezones that Serbian devices
//      commonly report (the Windows "Belgrade, Bratislava, Budapest,
//      Ljubljana, Prague" group maps to Europe/Budapest on many machines)
//      are deliberately NOT on that list, so a Serbian visitor is never
//      denied ads by this check. It is a fail-safe, not a geo lookup.
//
//   6. On takeover, every TCF consumer that registered through the proxy
//      (GPT, Prebid) immediately receives a synthetic final answer with
//      gdprApplies = false, and every later TCF call is answered the same
//      way. gdprApplies = false is the correct resolution for this site's
//      overwhelmingly Serbian (non-EEA) audience and is exactly how the
//      working consentmanager instances on this network resolve for them.
//
//   7. It is self-healing in both directions. If the account is fixed, the
//      design file arrives on every load and the watchdog never fires. If the
//      real CMP asserts itself after a takeover (a genuine "cmpuishown" or
//      final event), the proxy returns to pass-through, the synthetic answers
//      stop, and the GPT recovery refresh is never issued.
//
// Known limitation, accepted: a consumer that registered its listener
// directly with the broken CMP BEFORE this wrapper executed cannot be
// notified through the proxy; the consentmanager registry rescue below
// covers that case for this vendor specifically.
//
// Debugging: window.__cmpWatchdog exposes
// { wrapped, takenOver, cmpFinal, cmpHealthy, takeoverReason, timezone, timezoneBlocked }.

// After the CMP's configuration call (cmp.php) has completed, how long to wait
// for the design file request before concluding the configuration was empty.
// On a healthy load the design file follows within ~10 ms; 750 ms is a very
// wide margin.
var CMP_NO_DESIGN_CONFIRM_MILLISECONDS = 750;

// Absolute ceiling: if the CMP has shown no progress of any kind for this
// long after the proxy was installed, take over anyway (vendor unreachable).
// Generous on purpose: an EU visitor on a slow connection may need several
// seconds just for cmp.php (measured 2.6 s from Germany), and taking over
// before that would bypass their banner. Serbian visitors on the broken
// instance are not affected by this value at all -- their takeover comes from
// the empty-configuration signature at ~2 s.
var CMP_WATCHDOG_MAX_WAIT_MILLISECONDS = 8000;

// How often the watchdog re-evaluates the CMP's progress.
var CMP_WATCHDOG_POLL_MILLISECONDS = 250;

// Device timezones that identify an EEA/CH/UK visitor beyond reasonable doubt.
// The synthetic "GDPR does not apply" answer is never given to these. The
// list intentionally omits every zone a Serbian device might report:
// Europe/Belgrade itself, and the Windows group-default zones Europe/Budapest
// (Belgrade/Bratislava/Budapest/Ljubljana/Prague group) and Europe/Warsaw
// (Sarajevo/Skopje/Warsaw/Zagreb group), plus Prague, Bratislava, Ljubljana
// and Zagreb which share those groups.
var CMP_WATCHDOG_EEA_DEVICE_TIMEZONES = [
    'Europe/Berlin', 'Europe/Vienna', 'Europe/Zurich', 'Europe/Amsterdam',
    'Europe/Brussels', 'Europe/Luxembourg', 'Europe/Paris', 'Europe/Madrid',
    'Europe/Rome', 'Europe/Malta', 'Europe/Copenhagen', 'Europe/Stockholm',
    'Europe/Oslo', 'Europe/Helsinki', 'Europe/Athens', 'Europe/Bucharest',
    'Europe/Sofia', 'Europe/Vilnius', 'Europe/Riga', 'Europe/Tallinn',
    'Europe/Dublin', 'Europe/London', 'Europe/Lisbon', 'Atlantic/Reykjavik',
    'Atlantic/Madeira', 'Atlantic/Azores', 'Atlantic/Canary', 'Europe/Nicosia',
    'Asia/Nicosia', 'Europe/Vaduz'
];

// The CMP stub is normally installed by the template before this file runs,
// but load order is not guaranteed. If window.__tcfapi is not there yet, the
// watchdog polls for it this often, for at most this long, then gives up
// (no CMP on the page means nothing blocks ad serving and there is nothing
// to guard).
var CMP_APPEARANCE_POLL_MILLISECONDS = 200;
var CMP_APPEARANCE_MAX_WAIT_MILLISECONDS = 10000;

(function installCmpWatchdog() {

    // Read-only state for debugging from the console / remote sessions.
    var watchdogState = {
        wrapped: false,
        takenOver: false,
        cmpFinal: false,
        cmpHealthy: false,
        takeoverReason: null,
        timezone: null,
        timezoneBlocked: false
    };
    window.__cmpWatchdog = watchdogState;

    // The CMP's own __tcfapi function once the proxy is installed.
    var realTcfApi = null;

    // Every listener registered through the proxy, so the watchdog can answer
    // them itself on takeover. Each entry is { callback, syntheticListenerId }.
    var proxiedListeners = [];

    // Synthetic listener ids start high so they can never collide with ids
    // handed out by the real CMP.
    var nextSyntheticListenerId = 100000;

    // The progress poll timer, and when the proxy was installed (poll clock).
    var progressPollTimer = null;
    var proxyInstalledAtMilliseconds = 0;

    function logWatchdog(message) {
        try {
            console.log('[ads.js CMP watchdog] ' + message);
        } catch (ignored) {}
    }

    function nowMilliseconds() {
        return new Date().getTime();
    }

    // True while the watchdog's synthetic answers are in force: it has taken
    // over AND the real CMP has neither finished nor asserted itself since.
    function syntheticAnswersActive() {
        return watchdogState.takenOver && !watchdogState.cmpFinal && !watchdogState.cmpHealthy;
    }

    // -------------------------------------------------------------------------
    // Device timezone fail-safe (see point 5 in the header comment).
    // -------------------------------------------------------------------------
    function readDeviceTimezone() {
        try {
            var intlObject = window.Intl || (typeof Intl !== 'undefined' ? Intl : null);
            if (!intlObject || typeof intlObject.DateTimeFormat !== 'function') {
                return null;
            }
            var resolved = intlObject.DateTimeFormat().resolvedOptions();
            if (resolved && typeof resolved.timeZone === 'string' && resolved.timeZone.length > 0) {
                return resolved.timeZone;
            }
        } catch (timezoneError) {
            return null;
        }
        return null;
    }

    function deviceLooksEea() {
        var timezone = readDeviceTimezone();
        watchdogState.timezone = timezone;
        if (timezone === null) {
            // Unknown timezone (very old browser): cannot tell, do not block.
            return false;
        }
        var zoneIndex;
        for (zoneIndex = 0; zoneIndex < CMP_WATCHDOG_EEA_DEVICE_TIMEZONES.length; zoneIndex++) {
            if (CMP_WATCHDOG_EEA_DEVICE_TIMEZONES[zoneIndex] === timezone) {
                return true;
            }
        }
        return false;
    }

    // -------------------------------------------------------------------------
    // CMP progress detection through the resource timeline and the CMP's own
    // public state (see points 2-4 in the header comment).
    // -------------------------------------------------------------------------

    // Returns { configCallCompletedAt: ms-since-page-start or null,
    //           designFileRequested: bool }.
    //
    // The design file is requested by the CMP core as an async <script>
    // element appended to the document the moment cmp.php has executed
    // (measured: 2 ms later). Its download can take several seconds on a slow
    // connection, and a resource-timeline entry only exists once a download
    // has COMPLETED -- so an in-flight design file is invisible in the
    // timeline. The DOM is therefore checked first: a <script> whose src is a
    // consentmanager /delivery/customdata/ URL means the configuration
    // arrived and a design is being fetched, i.e. the CMP is working for this
    // visitor, whether or not the file has finished downloading yet.
    function inspectCmpNetworkActivity() {
        var result = { configCallCompletedAt: null, designFileRequested: false };
        try {
            var scriptElements = document.getElementsByTagName('script');
            var scriptIndex;
            for (scriptIndex = 0; scriptIndex < scriptElements.length; scriptIndex++) {
                var scriptSource = String(scriptElements[scriptIndex].src || '');
                if (scriptSource.indexOf('consentmanager') !== -1 && scriptSource.indexOf('/delivery/customdata/') !== -1) {
                    result.designFileRequested = true;
                    break;
                }
            }
        } catch (domError) {
            // fall through to the timeline check
        }
        try {
            if (!window.performance || typeof window.performance.getEntriesByType !== 'function') {
                return result;
            }
            var resourceEntries = window.performance.getEntriesByType('resource');
            var entryIndex;
            for (entryIndex = 0; entryIndex < resourceEntries.length; entryIndex++) {
                var resourceName = String(resourceEntries[entryIndex].name);
                if (resourceName.indexOf('consentmanager') === -1) {
                    continue;
                }
                if (resourceName.indexOf('/delivery/cmp.php') !== -1) {
                    // responseEnd is exposed for cross-origin resources even
                    // without Timing-Allow-Origin; a still-in-flight request
                    // does not appear in the timeline at all.
                    var responseEnd = resourceEntries[entryIndex].responseEnd;
                    if (typeof responseEnd === 'number' && responseEnd > 0) {
                        if (result.configCallCompletedAt === null || responseEnd < result.configCallCompletedAt) {
                            result.configCallCompletedAt = responseEnd;
                        }
                    }
                }
                if (resourceName.indexOf('/delivery/customdata/') !== -1 || resourceName.indexOf('/delivery/info/') !== -1) {
                    result.designFileRequested = true;
                }
            }
        } catch (performanceError) {
            return result;
        }
        return result;
    }

    // The consentmanager core exposes window.cmpmngr.status: it stays at 1 in
    // the broken state and advances (4 = banner shown, 6 = finished) once the
    // configuration has arrived. Any advance beyond 1 is progress.
    function cmpVendorStatusAdvanced() {
        try {
            var cmpVendorObject = window.cmpmngr;
            if (cmpVendorObject && typeof cmpVendorObject.status === 'number' && cmpVendorObject.status > 1) {
                return true;
            }
        } catch (statusError) {
            return false;
        }
        return false;
    }

    // Milliseconds since the page's time origin, on the same clock as the
    // resource timeline entries.
    function millisecondsSincePageStart() {
        try {
            if (window.performance && typeof window.performance.now === 'function') {
                return window.performance.now();
            }
        } catch (performanceError) {
            return 0;
        }
        return 0;
    }

    // Marks the CMP as genuinely working for this visitor and stands the
    // watchdog down permanently. Called on any progress signal.
    function markCmpHealthy(reason) {
        if (watchdogState.cmpHealthy) {
            return;
        }
        watchdogState.cmpHealthy = true;
        stopProgressPoll();
        if (watchdogState.takenOver) {
            logWatchdog('real CMP asserted itself after a takeover (' + reason + '); synthetic answers withdrawn, proxy back to pass-through.');
        } else {
            logWatchdog('CMP is progressing on its own (' + reason + '); watchdog stood down.');
        }
    }

    function stopProgressPoll() {
        if (progressPollTimer !== null) {
            clearInterval(progressPollTimer);
            progressPollTimer = null;
        }
    }

    // One evaluation of the CMP's progress; runs every
    // CMP_WATCHDOG_POLL_MILLISECONDS until a decision is reached.
    function evaluateCmpProgress() {
        if (watchdogState.cmpFinal || watchdogState.cmpHealthy || watchdogState.takenOver) {
            stopProgressPoll();
            return;
        }

        if (cmpVendorStatusAdvanced()) {
            markCmpHealthy('cmpmngr.status advanced past 1');
            return;
        }

        var networkActivity = inspectCmpNetworkActivity();
        if (networkActivity.designFileRequested) {
            markCmpHealthy('design file requested');
            return;
        }

        var elapsedSinceInstall = nowMilliseconds() - proxyInstalledAtMilliseconds;

        if (networkActivity.configCallCompletedAt !== null) {
            var sinceConfigCall = millisecondsSincePageStart() - networkActivity.configCallCompletedAt;
            if (sinceConfigCall >= CMP_NO_DESIGN_CONFIRM_MILLISECONDS) {
                takeOver('cmp.php completed ' + Math.round(sinceConfigCall) + 'ms ago and no design file followed (empty configuration for this visitor)');
                return;
            }
        }

        if (elapsedSinceInstall >= CMP_WATCHDOG_MAX_WAIT_MILLISECONDS) {
            takeOver('no CMP progress of any kind within ' + CMP_WATCHDOG_MAX_WAIT_MILLISECONDS + 'ms (vendor unreachable)');
            return;
        }
    }

    // A minimal but complete TCData object representing "GDPR does not apply".
    // Consumers only read gdprApplies/eventStatus/cmpStatus in this case, but
    // the usual containers are present so nothing trips over a missing field.
    function buildSyntheticTcData() {
        return {
            // Marker so the watchdog's own observers can tell a synthetic
            // answer from a genuine CMP recovery; harmless extra field for
            // every other TCF consumer.
            syntheticWatchdogAnswer: true,
            tcString: '',
            tcfPolicyVersion: 4,
            cmpId: 31,
            cmpVersion: 1,
            gdprApplies: false,
            eventStatus: 'tcloaded',
            cmpStatus: 'loaded',
            isServiceSpecific: true,
            useNonStandardTexts: false,
            publisherCC: 'RS',
            purposeOneTreatment: false,
            listenerId: null,
            purpose: { consents: {}, legitimateInterests: {} },
            vendor: { consents: {}, legitimateInterests: {} },
            specialFeatureOptins: {},
            publisher: {
                consents: {},
                legitimateInterests: {},
                customPurpose: { consents: {}, legitimateInterests: {} },
                restrictions: {}
            }
        };
    }

    function answerListenerSynthetically(listenerEntry) {
        var syntheticData = buildSyntheticTcData();
        syntheticData.listenerId = listenerEntry.syntheticListenerId;
        try {
            listenerEntry.callback(syntheticData, true);
        } catch (listenerError) {
            logWatchdog('a TCF listener threw while receiving the synthetic answer: ' + listenerError);
        }
    }

    // After a takeover, the proxy can only answer consumers that registered
    // THROUGH it. A consumer that registered before this file executed (GPT's
    // pubads implementation wins that race on some page loads) left its
    // callback inside the real CMP's own registry, forever waiting -- the
    // proxy cannot reach it. For the consentmanager CMP specifically, that
    // registry is publicly reachable at window.cmpmngr.api.events as entries
    // of shape { type: 'tcfv2', listener: function, id: number }, so the
    // watchdog answers those held listeners directly as well. Every step is
    // guarded: any unexpected shape (different CMP vendor, changed internals
    // after a consentmanager update) simply skips the rescue and the proxy
    // path still covers consumers that registered normally. A consumer that
    // registered through the proxy also appears in this registry and will
    // receive the synthetic answer twice; TCF listeners are event streams and
    // both GPT and Prebid handle a repeated final event idempotently.
    // Registry entries already answered, keyed by the CMP's own listener id, so
    // retries never answer the same consumer twice.
    var rescuedRegistryIds = {};

    function rescueCmpHeldListeners() {
        var rescuedCount = 0;
        try {
            var cmpVendorObject = window.cmpmngr;
            if (!cmpVendorObject || !cmpVendorObject.api || !cmpVendorObject.api.events || typeof cmpVendorObject.api.events.forEach !== 'function') {
                return 0;
            }
            cmpVendorObject.api.events.forEach(function (registryEntry) {
                if (!registryEntry || registryEntry.type !== 'tcfv2' || typeof registryEntry.listener !== 'function') {
                    return;
                }
                if (rescuedRegistryIds[registryEntry.id] === true) {
                    return;
                }
                rescuedRegistryIds[registryEntry.id] = true;
                var syntheticData = buildSyntheticTcData();
                syntheticData.listenerId = registryEntry.id;
                try {
                    registryEntry.listener(syntheticData, true);
                    rescuedCount = rescuedCount + 1;
                } catch (listenerError) {
                    logWatchdog('a CMP-held TCF listener threw while receiving the synthetic answer: ' + listenerError);
                }
            });
        } catch (rescueError) {
            logWatchdog('CMP-held listener rescue skipped: ' + rescueError);
        }
        return rescuedCount;
    }

    // The registry (window.cmpmngr) belongs to the CMP's full code, which loads
    // over the network and can appear AFTER the takeover fired -- and consumers
    // held in the CMP's stub queue only land in the registry when that code
    // processes the queue. A single rescue pass at takeover therefore misses
    // late arrivals (verified live on 03.09.2026: same build freed GPT on one
    // site and missed it on the other purely by load timing). So the rescue
    // repeats every second for a while after takeover, answering each newly
    // appeared captive listener exactly once, and stops early if the CMP
    // genuinely recovers or asserts itself.
    var CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS = 1000;
    var CMP_RESCUE_MAX_DURATION_MILLISECONDS = 30000;


    // Ad requests that GPT attempted WHILE it was still consent-blocked are
    // dropped, not queued -- freeing GPT afterwards does not resend them
    // (verified live on 03.09.2026: one site's request timing landed after the
    // rescue and rendered, the other site's landed before it and stayed blank
    // with zero gampad requests). So after the first rescue pass that actually
    // freed listeners, wait a moment and check whether ANY ad request has left
    // the page; if none has, issue a single recovery refresh of all GPT slots.
    // The completed Prebid auctions' targeting is already set on the slots, so
    // the recovery request serves with full header-bidding competition.
    // Never issued once the real CMP has asserted itself: for that visitor
    // ad requests must wait for the real consent outcome.
    var gptRedispatchScheduled = false;

    function scheduleGptRedispatchIfSilent() {
        if (gptRedispatchScheduled) {
            return;
        }
        gptRedispatchScheduled = true;
        setTimeout(function () {
            try {
                if (!syntheticAnswersActive()) {
                    logWatchdog('real CMP is in charge; recovery refresh not issued.');
                    return;
                }
                var observedAdRequestCount = 0;
                try {
                    var resourceEntries = [];
                    if (window.performance && typeof window.performance.getEntriesByType === 'function') {
                        resourceEntries = window.performance.getEntriesByType('resource');
                    }
                    var entryIndex;
                    for (entryIndex = 0; entryIndex < resourceEntries.length; entryIndex++) {
                        if (String(resourceEntries[entryIndex].name).indexOf('gampad/ads') !== -1) {
                            observedAdRequestCount = observedAdRequestCount + 1;
                        }
                    }
                } catch (performanceError) {
                    observedAdRequestCount = 0;
                }
                if (observedAdRequestCount > 0) {
                    logWatchdog('GPT already dispatched ' + observedAdRequestCount + ' ad request(s); no recovery refresh needed.');
                    return;
                }
                if (window.googletag && window.googletag.cmd) {
                    window.googletag.cmd.push(function () {
                        window.googletag.pubads().refresh();
                    });
                    logWatchdog('GPT sent no ad requests while consent was blocked; issued a one-time recovery refresh of all slots.');
                }
            } catch (redispatchError) {
                logWatchdog('GPT recovery refresh skipped: ' + redispatchError);
            }
        }, 1500);
    }

    function startCmpRegistryRescueLoop() {
        var firstPassCount = rescueCmpHeldListeners() + rescueGppRegistryListeners();
        if (firstPassCount > 0) {
            logWatchdog('rescued ' + firstPassCount + ' listener(s) held inside the CMP registry (consumers that registered before this file executed).');
            scheduleGptRedispatchIfSilent();
        }
        var elapsedMilliseconds = 0;
        var rescueTimer = setInterval(function () {
            if (!syntheticAnswersActive()) {
                clearInterval(rescueTimer);
                return;
            }
            var passCount = rescueCmpHeldListeners() + rescueGppRegistryListeners();
            if (passCount > 0) {
                logWatchdog('rescued ' + passCount + ' more CMP-held listener(s) on a retry pass.');
                scheduleGptRedispatchIfSilent();
            }
            elapsedMilliseconds = elapsedMilliseconds + CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS;
            if (elapsedMilliseconds >= CMP_RESCUE_MAX_DURATION_MILLISECONDS) {
                clearInterval(rescueTimer);
            }
        }, CMP_RESCUE_RETRY_INTERVAL_MILLISECONDS);
    }

    // Marks the CMP as finished and stands the watchdog down. Called whenever a
    // real final event is observed through the proxy.
    function markCmpFinal() {
        if (watchdogState.cmpFinal) {
            return;
        }
        watchdogState.cmpFinal = true;
        stopProgressPoll();
        logWatchdog('CMP reached a final state on its own; watchdog stood down.');
    }

    function takeOver(reason) {
        if (watchdogState.takenOver || watchdogState.cmpFinal || watchdogState.cmpHealthy) {
            return;
        }
        stopProgressPoll();

        // Fail-safe: never bypass consent for a device that is clearly in the
        // EEA. For that visitor the watchdog does nothing at all.
        if (deviceLooksEea()) {
            watchdogState.timezoneBlocked = true;
            logWatchdog('CMP looks broken (' + reason + ') but the device timezone is ' + watchdogState.timezone +
                ' (EEA); leaving consent to the real CMP, no synthetic answer for this visitor.');
            return;
        }

        watchdogState.takenOver = true;
        watchdogState.takeoverReason = reason;
        logWatchdog(
            'taking over: ' + reason + '; answering ' + proxiedListeners.length +
            ' registered TCF listener(s) with gdprApplies=false so ad serving can proceed.');
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < proxiedListeners.length; listenerIndex++) {
            answerListenerSynthetically(proxiedListeners[listenerIndex]);
        }
        takeOverGpp();
        startCmpRegistryRescueLoop();
    }

    // Watches a real CMP event. Final states per the TCF spec are "tcloaded"
    // (no UI needed) and "useractioncomplete" (user answered the banner).
    // "cmpuishown" is not final but proves the CMP is configured and working
    // for this visitor, so it counts as the CMP asserting itself.
    function observeRealEvent(tcData) {
        // A synthetic answer produced by this watchdog (delivered back to us
        // through the CMP registry rescue) must never count as the CMP
        // recovering -- only genuine CMP events may stand the watchdog down.
        if (tcData && tcData.syntheticWatchdogAnswer) {
            return;
        }
        if (!tcData) {
            return;
        }
        if (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') {
            markCmpHealthy('real final event ' + tcData.eventStatus);
            markCmpFinal();
            return;
        }
        if (tcData.eventStatus === 'cmpuishown' || tcData.cmpStatus === 'loaded') {
            markCmpHealthy('real event ' + tcData.eventStatus + ' / cmpStatus ' + tcData.cmpStatus);
        }
    }



    // Consumers inside iframes -- and, on some pages, GPT itself -- talk to
    // the CMP through the TCF postMessage protocol aimed at the
    // __tcfapiLocator frame instead of calling window.__tcfapi directly.
    // Those requests never pass through the function proxy above, so after a
    // takeover the watchdog answers them here as well. Verified live on sd.rs
    // (03.09.2026): GPT bound itself to the postMessage path and stayed
    // blocked even after the function-path rescue -- __tcfapiCall messages
    // flowed with ZERO __tcfapiReturn replies from the broken CMP. While the
    // CMP is healthy (or before a takeover) this responder stays silent, and
    // it stands down permanently if the real CMP asserts itself.
    function installPostMessageResponder() {
        window.addEventListener('message', function (messageEvent) {
            if (!syntheticAnswersActive()) {
                return;
            }
            var payload = messageEvent && messageEvent.data;
            var usedJsonEncoding = false;
            if (typeof payload === 'string') {
                if (payload.indexOf('__tcfapiCall') === -1) {
                    return;
                }
                try {
                    payload = JSON.parse(payload);
                    usedJsonEncoding = true;
                } catch (parseError) {
                    return;
                }
            }
            if (!payload || !payload.__tcfapiCall || !messageEvent.source) {
                return;
            }
            var tcfCall = payload.__tcfapiCall;
            var returnValue;
            if (tcfCall.command === 'ping') {
                returnValue = {
                    gdprApplies: false,
                    cmpLoaded: true,
                    cmpStatus: 'loaded',
                    displayStatus: 'disabled',
                    apiVersion: '2.2',
                    cmpId: 31
                };
            } else {
                returnValue = buildSyntheticTcData();
            }
            var reply = { __tcfapiReturn: { returnValue: returnValue, success: true, callId: tcfCall.callId } };
            try {
                messageEvent.source.postMessage(usedJsonEncoding ? JSON.stringify(reply) : reply, '*');
            } catch (postError) {
                return;
            }
            // A consumer reached through this path may also have had its ad
            // requests dropped while blocked; make sure the one-time recovery
            // refresh check runs for this path too.
            if (tcfCall.command === 'addEventListener' || tcfCall.command === 'getTCData') {
                scheduleGptRedispatchIfSilent();
            }
        }, false);
    }

    // =========================================================================
    // GPP (GLOBAL PRIVACY PLATFORM) WATCHDOG
    // =========================================================================
    //
    // The same broken CMP that blocks TCF also implements a second, independent
    // consent signal API: GPP (Global Privacy Platform, used for US state
    // privacy laws and other non-EU frameworks). It fails identically:
    // window.__gpp answers every query with cmpStatus "loading" and
    // signalStatus "not ready" forever. Google Publisher Tag consults GPP in
    // addition to TCF before it will request ads, so even after the TCF
    // watchdog above frees GPT, a stuck GPP signal can still block ad serving
    // on its own. Confirmed live on sd.rs on 03.09.2026: TCF was fully
    // resolved (registry rescue answered every tcfv2 listener, prebid ran a
    // complete auction), yet zero ad requests ever fired until GPP was also
    // freed here.
    //
    // Mirrors the TCF watchdog's three surfaces -- the window.__gpp function,
    // the consentmanager registry (entries with type 'gpp'), and the
    // postMessage protocol via the __gppLocator frame -- and fires on the same
    // takeover as TCF. A healthy GPP resolves on its own and this code never
    // engages.

    var gppRealApi = null;
    var gppProxiedListeners = [];
    var gppNextSyntheticListenerId = 300000;
    var gppRescuedRegistryIds = {};

    // A resolved-and-nothing-applies GPP signal: no section of any privacy
    // framework currently applies, which is the correct declaration when the
    // audience is not covered by the regulations GPP encodes (this wrapper's
    // watchdog already declares the TCF/GDPR equivalent above for the same
    // non-EEA audience).
    function buildSyntheticGppPingData() {
        return {
            gppVersion: '1.1',
            cmpStatus: 'loaded',
            cmpDisplayStatus: 'hidden',
            signalStatus: 'ready',
            supportedAPIs: [],
            cmpId: 31,
            sectionList: [],
            applicableSections: [],
            gppString: '',
            parsedSections: {}
        };
    }

    // GPP's addEventListener callback receives an "event" object, not the ping
    // data directly. Different integrations read either event.data (spec says
    // a plain 'ready' string for the signalStatus event) or the ping-shaped
    // fields nested under event.pingData -- both are populated here, same
    // belt-and-braces approach as the TCF synthetic answer above.
    function buildSyntheticGppEvent(listenerId) {
        return {
            eventName: 'signalStatus',
            listenerId: listenerId,
            data: 'ready',
            pingData: buildSyntheticGppPingData()
        };
    }

    function answerGppListenerSynthetically(listenerEntry) {
        try {
            listenerEntry.callback(buildSyntheticGppEvent(listenerEntry.syntheticListenerId), true);
        } catch (listenerError) {
            logWatchdog('a GPP listener threw while receiving the synthetic answer: ' + listenerError);
        }
    }

    function takeOverGpp() {
        var listenerIndex;
        for (listenerIndex = 0; listenerIndex < gppProxiedListeners.length; listenerIndex++) {
            answerGppListenerSynthetically(gppProxiedListeners[listenerIndex]);
        }
        rescueGppRegistryListeners();
    }

    // Same shape as the TCF registry rescue, filtered to type 'gpp' entries;
    // deduped by registry id so a repeat retry pass never answers twice.
    function rescueGppRegistryListeners() {
        var rescuedCount = 0;
        try {
            var cmpVendorObject = window.cmpmngr;
            if (!cmpVendorObject || !cmpVendorObject.api || !cmpVendorObject.api.events || typeof cmpVendorObject.api.events.forEach !== 'function') {
                return 0;
            }
            cmpVendorObject.api.events.forEach(function (registryEntry) {
                if (!registryEntry || registryEntry.type !== 'gpp' || typeof registryEntry.listener !== 'function') {
                    return;
                }
                if (gppRescuedRegistryIds[registryEntry.id] === true) {
                    return;
                }
                gppRescuedRegistryIds[registryEntry.id] = true;
                try {
                    registryEntry.listener(buildSyntheticGppEvent(registryEntry.id), true);
                    rescuedCount = rescuedCount + 1;
                } catch (listenerError) {
                    logWatchdog('a CMP-held GPP listener threw while receiving the synthetic answer: ' + listenerError);
                }
            });
        } catch (rescueError) {
            logWatchdog('GPP registry rescue skipped: ' + rescueError);
        }
        return rescuedCount;
    }

    function installGppProxy() {
        if (typeof window.__gpp !== 'function') {
            return;
        }
        gppRealApi = window.__gpp;

        window.__gpp = function proxiedGpp(command, callback, parameter) {

            if (command === 'addEventListener' && typeof callback === 'function') {
                var listenerEntry = {
                    callback: callback,
                    syntheticListenerId: gppNextSyntheticListenerId
                };
                gppNextSyntheticListenerId = gppNextSyntheticListenerId + 1;
                gppProxiedListeners.push(listenerEntry);

                if (syntheticAnswersActive()) {
                    answerGppListenerSynthetically(listenerEntry);
                }

                gppRealApi(command, function (event, success) {
                    if (syntheticAnswersActive()) {
                        return;
                    }
                    callback(event, success);
                }, parameter);
                return;
            }

            if (command === 'removeEventListener') {
                var entryIndex;
                for (entryIndex = 0; entryIndex < gppProxiedListeners.length; entryIndex++) {
                    if (gppProxiedListeners[entryIndex].syntheticListenerId === parameter) {
                        gppProxiedListeners.splice(entryIndex, 1);
                        if (typeof callback === 'function') {
                            callback(true);
                        }
                        return;
                    }
                }
                gppRealApi(command, callback, parameter);
                return;
            }

            if (syntheticAnswersActive()) {
                if (typeof callback === 'function') {
                    callback(buildSyntheticGppPingData(), true);
                    return;
                }
                return;
            }

            gppRealApi(command, callback, parameter);
        };
    }

    // Consumers reaching GPP through postMessage (__gppCall / __gppReturn via
    // the __gppLocator frame), same reasoning as the TCF postMessage responder
    // above: some consumers, including GPT itself on some page loads, never
    // call window.__gpp directly.
    function installGppPostMessageResponder() {
        window.addEventListener('message', function (messageEvent) {
            if (!syntheticAnswersActive()) {
                return;
            }
            var payload = messageEvent && messageEvent.data;
            var usedJsonEncoding = false;
            if (typeof payload === 'string') {
                if (payload.indexOf('__gppCall') === -1) {
                    return;
                }
                try {
                    payload = JSON.parse(payload);
                    usedJsonEncoding = true;
                } catch (parseError) {
                    return;
                }
            }
            if (!payload || !payload.__gppCall || !messageEvent.source) {
                return;
            }
            var gppCallInfo = payload.__gppCall;
            var returnValue = gppCallInfo.command === 'addEventListener'
                ? buildSyntheticGppEvent(gppCallInfo.callId)
                : buildSyntheticGppPingData();
            var reply = { __gppReturn: { returnValue: returnValue, success: true, callId: gppCallInfo.callId } };
            try {
                messageEvent.source.postMessage(usedJsonEncoding ? JSON.stringify(reply) : reply, '*');
            } catch (postError) {
                return;
            }
            scheduleGptRedispatchIfSilent();
        }, false);
    }


    function installProxy() {
        realTcfApi = window.__tcfapi;
        watchdogState.wrapped = true;
        installPostMessageResponder();
        installGppProxy();
        installGppPostMessageResponder();

        window.__tcfapi = function proxiedTcfApi(command, version, callback, parameter) {

            // --- addEventListener -------------------------------------------
            // Record the consumer so the watchdog can answer it on takeover,
            // and ALWAYS forward the registration to the real CMP so that a
            // healthy (or later-asserting) CMP drives the consumer normally.
            if (command === 'addEventListener' && typeof callback === 'function') {
                var listenerEntry = {
                    callback: callback,
                    syntheticListenerId: nextSyntheticListenerId
                };
                nextSyntheticListenerId = nextSyntheticListenerId + 1;
                proxiedListeners.push(listenerEntry);

                if (syntheticAnswersActive()) {
                    // Late consumer after takeover: answer immediately so it
                    // never hangs, and still register with the real CMP below
                    // in case it asserts itself.
                    answerListenerSynthetically(listenerEntry);
                }

                realTcfApi(command, version, function (tcData, success) {
                    observeRealEvent(tcData);
                    // While synthetic answers are in force, suppress the CMP's
                    // eternal "loading" pings; only real progress is worth
                    // forwarding then (and observeRealEvent just lifted the
                    // suppression if this event was real progress).
                    if (syntheticAnswersActive()) {
                        return;
                    }
                    callback(tcData, success);
                }, parameter);
                return;
            }

            // --- removeEventListener ----------------------------------------
            // If the id is one of the watchdog's synthetic ids, confirm the
            // removal locally (the real CMP has never heard of that id).
            if (command === 'removeEventListener') {
                var entryIndex;
                for (entryIndex = 0; entryIndex < proxiedListeners.length; entryIndex++) {
                    if (proxiedListeners[entryIndex].syntheticListenerId === parameter) {
                        proxiedListeners.splice(entryIndex, 1);
                        if (typeof callback === 'function') {
                            callback(true);
                        }
                        return;
                    }
                }
                realTcfApi(command, version, callback, parameter);
                return;
            }

            // --- getTCData / ping / everything else -------------------------
            // While synthetic answers are in force, answer one-shot queries
            // synthetically (the real CMP would only ever say "loading"
            // again). Otherwise pure pass-through, with a peek at the answer
            // to spot progress or a final state.
            if (syntheticAnswersActive()) {
                if (command === 'ping' && typeof callback === 'function') {
                    callback({
                        gdprApplies: false,
                        cmpLoaded: true,
                        cmpStatus: 'loaded',
                        displayStatus: 'disabled',
                        apiVersion: '2.2',
                        cmpId: 31
                    }, true);
                    return;
                }
                if (typeof callback === 'function') {
                    callback(buildSyntheticTcData(), true);
                    return;
                }
                return;
            }

            realTcfApi(command, version, function (tcData, success) {
                observeRealEvent(tcData);
                if (typeof callback === 'function') {
                    callback(tcData, success);
                }
            }, parameter);
        };

        // The watchdog's own observer: register with the real CMP so progress
        // or a final state is noticed even if no other consumer ever registers.
        realTcfApi('addEventListener', 2, function (tcData, success) {
            if (success !== false) {
                observeRealEvent(tcData);
            }
        });

        proxyInstalledAtMilliseconds = nowMilliseconds();
        progressPollTimer = setInterval(evaluateCmpProgress, CMP_WATCHDOG_POLL_MILLISECONDS);
        logWatchdog('proxy installed; watching CMP progress (takeover ' + CMP_NO_DESIGN_CONFIRM_MILLISECONDS +
            'ms after an empty configuration answer, or after ' + CMP_WATCHDOG_MAX_WAIT_MILLISECONDS + 'ms without any progress).');
    }

    // The CMP stub normally exists before this file runs; if not, poll for a
    // while in case the template loads it late. No CMP at all means nothing
    // blocks ad serving, so the watchdog simply never engages.
    if (typeof window.__tcfapi === 'function') {
        installProxy();
    } else {
        var appearanceWaitedMilliseconds = 0;
        var appearancePollTimer = setInterval(function () {
            if (typeof window.__tcfapi === 'function') {
                clearInterval(appearancePollTimer);
                installProxy();
                return;
            }
            appearanceWaitedMilliseconds = appearanceWaitedMilliseconds + CMP_APPEARANCE_POLL_MILLISECONDS;
            if (appearanceWaitedMilliseconds >= CMP_APPEARANCE_MAX_WAIT_MILLISECONDS) {
                clearInterval(appearancePollTimer);
                logWatchdog('no __tcfapi appeared within ' + CMP_APPEARANCE_MAX_WAIT_MILLISECONDS + 'ms; nothing to guard.');
            }
        }, CMP_APPEARANCE_POLL_MILLISECONDS);
    }
})();

// ID5 for secure signals sharing in GAM
window.ID5EspConfig = { 
    partnerId: 1355 // ID5 partnerId
};

// Amount of time (ms) that Prebid allows the bidders to respond to ad requests.
var PREBID_TIMEOUT = 1500;

// Number of seconds to wait after the slot becomes viewable.
var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;

// Advertisers for which refresh shouldn't apply. Just add the company IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ADVERTISER_IDS = [];

// Campaigns for which refresh shouldn't apply. Just add the order IDs e.g [3219368852, 3130234283].
var GAM_NOREFRESH_ORDER_IDS = [];

// Ad units (div ids) for which refresh shouldn't apply. Just add the div IDs e.g ['Branding_Left', 'Branding_Right'].
var GAM_NOREFRESH_ADUNITS = ['Branding_Left', 'Branding_Right'];

// How far should the ad be for the lazy loading to activate.
var DISTANCE_IN_PIXELS_FOR_LAZY_LOADING = "350px";

// How much (in percent) should the ad slot be viewable. 
var VISIBILITY_PERCENT_FOR_REFRESH = 0.7;

// Variables for all defined slots. 
var Adhesion;
var Billboard;
var Billboard_2;
var Billboard_3;
var Billboard_4;
var Branding_Left;
var Branding_Right;
var P1_Desktop;
var P1_Mobile;
var P2_Desktop;
var P2_Mobile;
var P3;
var P4;
var P5;
var P6;
var In_Text_1;
var In_Text_2;
var In_Text_3;
var In_Text_4;
var In_Text_5;
var In_Text_6;
var In_Text_7;
var In_Text_8;
var In_Text_9;
var In_Text_10;

// Top level ad unit path. 
var adUnitPath = "/161634325,23035186899/Nin.rs/";

var adWindowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

// ATF and BTF array variables. 
var adUnitsATF = [];
var adUnitsBTF = [];

function runWrapper() {

    //console.log('Ad Wrapper: Script execution.');

    var adContainers = document.querySelectorAll('.wrapperAd'); // Find all divs which have wrapperAd class.

    var atfSlotsToRefresh = []; // Initial ATF GPT slots refreshed once after Prebid targeting is ready.

    googletag.cmd.push(function() { // Push the defined ad units to the GPT array.

        // Sticky GPT size mapping. 
        var sticky_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[728, 90], [970, 90], [980, 90], [1000, 100], [750, 100], [1, 1]]) //desktop
        .addSize([469, 0], [[468, 60], [300, 50], [320, 50], [1, 1]]) //tablet
        .addSize([0, 0], [[300, 50], [320, 50], [300, 100], [320, 100], [1, 1]]) //mobile
        .build();

        // Billboard GPT size mapping.
        var billboard_mapping = googletag.sizeMapping()
        .addSize([1600, 0], [[750, 250], [800, 250], [970, 250], [1060, 250], [1100, 250], [1500, 250]]) //desktop
        .addSize([1024, 0], [[970, 250], [750, 250], [800, 250]]) //desktop
        .addSize([469, 0], [[728, 90], [468, 60]]) //tablet
        .addSize([0, 0], [[300, 50], [320, 50], [300, 100], [320, 100]]) //mobile
        .build();

        // P GPT size mapping.
        var p_mapping = googletag.sizeMapping()
        .addSize([1024, 0], [[200, 200], [250, 250], [300, 250], [120, 600], [160, 600], [300, 600]]) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250]]) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280]]) //mobile
        .build();

        var inText_mapping = googletag.sizeMapping()
        .addSize([1300, 0], [[750, 250], [580, 280], [200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //desktop
        .addSize([469, 0], [[200, 200], [250, 250], [300, 250], 'fluid']) //tablet
        .addSize([0, 0], [[200, 200], [250, 250], [300, 250], [320, 250], [320, 240], [336, 280], 'fluid']) //mobile
        .build();


        // Branding GPT size mapping.
        var branding_mapping = googletag.sizeMapping()
        .addSize([1600, 0], [[120, 600], [160, 600]]) //desktop
        .addSize([0, 0], []) //tablet & mobile
        .build();


        adContainers.forEach(function(el) { // Runs through all of the wrapperAd divs.

            // **************** Sticky GPT and Prebid definition. *******************

            if (el.id === 'Adhesion') { // Check if Adhesion div is present in body. 

                // Sticky ad unit definition
                Adhesion = googletag.defineSlot(adUnitPath + 'Sticky', [[728, 90], [970, 90], [320, 50]], 'Adhesion')
                                    .defineSizeMapping(sticky_mapping)
                                    .setTargeting('position', 'Adhesion')
                                    .setTargeting('refresh_count', '0')
                                    .addService(googletag.pubads());

                // Push the defined Adhesion Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Adhesion',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1600, 0], sizes: [[728, 90], [970, 90], [750, 100]] }, //desktop for bigger screens
                            { minViewPort: [1024, 0], sizes: [728, 90] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189865'}},
                            {bidder: 'mediapool', params: {mid: '2043486', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201012'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756148'}},
                            {bidder: "richaudience", params: {pid: "Ybhsap9oy0", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719102}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120620'}},
                            {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                        ]
                    }
                );

            }

            // **************** Billboard GPT definition. *******************

            else if (el.id === 'Billboard') { // Check if Billboard div is present in body. 

                // Billboard ad unit definition
                Billboard = googletag.defineSlot(adUnitPath + 'Billboard', [[970, 250]], 'Billboard')
                                     .defineSizeMapping(billboard_mapping)
                                     .setTargeting('position', 'Billboard')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());

                // Push the defined Billboard Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'Billboard',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1600, 0], sizes: [[970, 250]] }, //desktop for bigger screens
                            { minViewPort: [1024, 0], sizes: [728, 90] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189866'}},
                            {bidder: 'mediapool', params: {mid: '2043487', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201015'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756152'}},
                            {bidder: "richaudience", params: {pid: "phpDSwFBpi", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719104}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120620'}},
                            {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                        ]
                    }
                );

            }

            // **************** In_Text_1 GPT definition. *******************

            else if (el.id === 'In_Text_1') { // Check if In_Text_1 div is present in body. 

                // In_Text_1 ad unit definition
                In_Text_1 = googletag.defineSlot(adUnitPath + 'In_Text_1', [[300, 250]], 'In_Text_1')
                                .defineSizeMapping(inText_mapping)
                                .setTargeting('position', 'In_Text_1')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                // Push the defined In_Text_1 Prebid placement IDs to the ATF array.      
                adUnitsATF.push(
                    {   code: 'In_Text_1',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189876'}},
                            {bidder: 'mediapool', params: {mid: '2043490', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201037'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756196'}},
                            {bidder: "richaudience", params: {pid: "elSradwpeY", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719124}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120627'}},
                            {bidder: 'teads', params: {pageId: 222368, placementId: 238988}},
                        ]
                    }
                );

            }  

            // **************** In_Text_2 GPT definition. *******************

            else if (el.id === 'In_Text_2') { // Check if In_Text_2 div is present in body. 

                // In_Text_2 ad unit definition
                In_Text_2 = googletag.defineSlot(adUnitPath + 'In_Text_2', [[300, 250]], 'In_Text_2')
                                .defineSizeMapping(inText_mapping)
                                .setTargeting('position', 'In_Text_2')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                // Push the defined In_Text_2 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189877'}},
                            {bidder: 'mediapool', params: {mid: '2043490', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201040'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756203'}},
                            {bidder: "richaudience", params: {pid: "c5dVL54cLD", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719126}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120628'}},
                            {bidder: 'teads', params: {pageId: 222368, placementId: 238988}},
                        ]
                    }
                );

            }  

            // **************** In_Text_3 GPT definition. *******************

            else if (el.id === 'In_Text_3') { // Check if In_Text_3 div is present in body. 

                // In_Text_3 ad unit definition
                In_Text_3 = googletag.defineSlot(adUnitPath + 'In_Text_3', [[300, 250]], 'In_Text_3')
                                .defineSizeMapping(inText_mapping)
                                .setTargeting('position', 'In_Text_3')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                // Push the defined In_Text_3 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_3',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189878'}},
                            {bidder: 'mediapool', params: {mid: '2043490', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201042'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756205'}},
                            {bidder: "richaudience", params: {pid: "xzTpEsHHqC", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719128}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120629'}},
                            {bidder: 'teads', params: {pageId: 222368, placementId: 238988}},
                        ]
                    }
                );

            }  
            
            // **************** In_Text_4 GPT definition. *******************

            else if (el.id === 'In_Text_4') { // Check if In_Text_4 div is present in body. 

                // In_Text_4 ad unit definition
                In_Text_4 = googletag.defineSlot(adUnitPath + 'In_Text_4', [[300, 250]], 'In_Text_4')
                                .defineSizeMapping(inText_mapping)
                                .setTargeting('position', 'In_Text_4')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                // Push the defined In_Text_4 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_4',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189879'}},
                            {bidder: 'mediapool', params: {mid: '2043490', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201044'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756206'}},
                            {bidder: "richaudience", params: {pid: "c0JpFsSeIY", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719130}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '124582'}},
                            {bidder: 'teads', params: {pageId: 222368, placementId: 238988}},
                        ]
                    }
                );

            }  

            // **************** In_Text_5 GPT definition. *******************

            else if (el.id === 'In_Text_5') { // Check if In_Text_5 div is present in body. 

                // In_Text_5 ad unit definition
                In_Text_5 = googletag.defineSlot(adUnitPath + 'In_Text_5', [[300, 250]], 'In_Text_5')
                                .defineSizeMapping(inText_mapping)
                                .setTargeting('position', 'In_Text_5')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                // Push the defined In_Text_5 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_5',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189880'}},
                            {bidder: 'mediapool', params: {mid: '2043490', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201047'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756207'}},
                            {bidder: "richaudience", params: {pid: "c5JQCK56Da", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719132}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120627'}},
                            {bidder: 'teads', params: {pageId: 222368, placementId: 238988}},
                        ]
                    }
                );

            }  

            // **************** In_Text_6 GPT definition. *******************

            else if (el.id === 'In_Text_6') { // Check if In_Text_6 div is present in body. 

                // In_Text_6 ad unit definition
                In_Text_6 = googletag.defineSlot(adUnitPath + 'In_Text_6', [[300, 250]], 'In_Text_6')
                                .defineSizeMapping(inText_mapping)
                                .setTargeting('position', 'In_Text_6')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                // Push the defined In_Text_6 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_6',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189881'}},
                            {bidder: 'mediapool', params: {mid: '2043490', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201049'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756208'}},
                            {bidder: "richaudience", params: {pid: "NpKj5qgmM9", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719134}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '125172'}},
                            {bidder: 'teads', params: {pageId: 222368, placementId: 238988}},
                        ]
                    }
                );

            }  

            // **************** In_Text_7 GPT definition. *******************

            else if (el.id === 'In_Text_7') { // Check if In_Text_7 div is present in body. 

                // In_Text_7 ad unit definition
                In_Text_7 = googletag.defineSlot(adUnitPath + 'In_Text_7', [[300, 250]], 'In_Text_7')
                                .defineSizeMapping(inText_mapping)
                                .setTargeting('position', 'In_Text_7')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                 // Push the defined In_Text_7 Prebid placement IDs to the ATF array.      
                 adUnitsBTF.push(
                    {   code: 'In_Text_7',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189882'}},
                            {bidder: 'mediapool', params: {mid: '2043490', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201050'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756211'}},
                            {bidder: "richaudience", params: {pid: "20bgivMpI8", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719136}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '125173'}},
                            {bidder: 'teads', params: {pageId: 222368, placementId: 238988}},
                        ]
                    }
                );                               
                    
            }  

            // **************** In_Text_8 GPT definition. *******************

            else if (el.id === 'In_Text_8') { // Check if In_Text_8 div is present in body. 

                // In_Text_8 ad unit definition
                In_Text_8 = googletag.defineSlot(adUnitPath + 'In_Text_8', [[300, 250]], 'In_Text_8')
                                .defineSizeMapping(inText_mapping)
                                .setTargeting('position', 'In_Text_8')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                // Push the defined In_Text_8 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_8',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189883'}},
                            {bidder: 'mediapool', params: {mid: '2043490', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201052'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756217'}},
                            {bidder: "richaudience", params: {pid: "cc78OcvbwB", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719138}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '125174'}},
                            {bidder: 'teads', params: {pageId: 222368, placementId: 238988}},
                        ]
                    }
                );

            }  

            // **************** In_Text_9 GPT definition. *******************

            else if (el.id === 'In_Text_9') { // Check if In_Text_9 div is present in body. 

                // In_Text_9 ad unit definition
                In_Text_9 = googletag.defineSlot(adUnitPath + 'In_Text_9', [[300, 250]], 'In_Text_9')
                                .defineSizeMapping(inText_mapping)
                                .setTargeting('position', 'In_Text_9')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                // Push the defined In_Text_9 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_9',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189884'}},
                            {bidder: 'mediapool', params: {mid: '2043490', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201055'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756219'}},
                            {bidder: "richaudience", params: {pid: "1wmxum3IzT", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719140}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '125175'}},
                            {bidder: 'teads', params: {pageId: 222368, placementId: 238988}},
                        ]
                    }
                );

            }  

            // **************** In_Text_10 GPT definition. *******************

            else if (el.id === 'In_Text_10') { // Check if In_Text_10 div is present in body. 

                // In_Text_10 ad unit definition
                In_Text_10 = googletag.defineSlot(adUnitPath + 'In_Text_10', [[300, 250]], 'In_Text_10')
                                .defineSizeMapping(inText_mapping)
                                .setTargeting('position', 'In_Text_10')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                // Push the defined In_Text_10 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'In_Text_10',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1024, 0], sizes: [[300, 250], [336, 280]] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189885'}},
                            {bidder: 'mediapool', params: {mid: '2043490', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201056'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756220'}},
                            {bidder: "richaudience", params: {pid: "pi8l1eCZLn", supplyType: "site"}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719142}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '125176'}},
                            {bidder: 'teads', params: {pageId: 222368, placementId: 238988}},
                        ]
                    }
                );

            }  

            if (adWindowWidth >= 1600) {

                // **************** Billboard_2 GPT definition. *******************

                if (el.id === 'Billboard_2') { // Check if Billboard_2 div is present in body. 

                    // Billboard_2 ad unit definition
                    Billboard_2 = googletag.defineSlot(adUnitPath + 'Billboard_2', [[970, 250]], 'Billboard_2')
                                        .defineSizeMapping(billboard_mapping)
                                        .setTargeting('position', 'Billboard_2')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                // Push the defined Billboard_2 Prebid placement IDs to the ATF array.      
                adUnitsBTF.push(
                    {   code: 'Billboard_2',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1600, 0], sizes: [[970, 250]] }, //desktop for bigger screens
                            { minViewPort: [1024, 0], sizes: [728, 90] }, //desktop for smaller screens
                            { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                            { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1189867'}},
                            {bidder: 'mediapool', params: {mid: '2043489', priceType: 'net'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201017'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756157'}},
                            {bidder: "richaudience", params: {pid: "4Id9Qj5len", supplyType: "site"}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719106}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '125758'}},
                            {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                        ]
                    }
                );

                }

                // **************** Billboard_3 GPT definition. *******************

                else if (el.id === 'Billboard_3') { // Check if Billboard_3 div is present in body. 

                    // Billboard_3 ad unit definition
                    Billboard_3 = googletag.defineSlot(adUnitPath + 'Billboard_3', [[970, 250]], 'Billboard_3')
                                        .defineSizeMapping(billboard_mapping)
                                        .setTargeting('position', 'Billboard_3')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined Billboard_3 Prebid placement IDs to the ATF array.      
                    adUnitsBTF.push(
                        {   code: 'Billboard_3',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1600, 0], sizes: [[970, 250]] }, //desktop for bigger screens
                                { minViewPort: [1024, 0], sizes: [728, 90] }, //desktop for smaller screens
                                { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                            ]
                            }},
                            bids: [
                                {bidder: 'criteo', params: {networkId: 9517}},
                                {bidder: "eskimi", params: {placementId: 3201}},
                                {bidder: 'ix', params: {siteId: '1189868'}},
                                {bidder: 'mediapool', params: {mid: '2043489', priceType: 'net'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201019'}},
                                {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756166'}},
                                {bidder: "richaudience", params: {pid: "gW2UGJWY8g", supplyType: "site"}},
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719108}},
                                {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                                {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '125759'}},
                                {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                            ]
                        }

                    );                                       

                }

                // **************** Billboard_4 GPT definition. *******************

                else if (el.id === 'Billboard_4') { // Check if Billboard_4 div is present in body. 

                    // Billboard_4 ad unit definition
                    Billboard_4 = googletag.defineSlot(adUnitPath + 'Billboard_4', [[970, 250]], 'Billboard_4')
                                        .defineSizeMapping(billboard_mapping)
                                        .setTargeting('position', 'Billboard_4')
                                        .setTargeting('refresh_count', '0')
                                        .addService(googletag.pubads());

                    // Push the defined Billboard_4 Prebid placement IDs to the ATF array.      
                    adUnitsBTF.push(
                        {   code: 'Billboard_4',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1600, 0], sizes: [[970, 250]] }, //desktop for bigger screens
                                { minViewPort: [1024, 0], sizes: [728, 90] }, //desktop for smaller screens
                                { minViewPort: [469, 0], sizes: [[468, 60]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 50], [320, 50], [300, 100], [320, 100]] }, //mobile
                            ]
                            }},
                            bids: [
                                {bidder: 'criteo', params: {networkId: 9517}},
                                {bidder: "eskimi", params: {placementId: 3201}},
                                {bidder: 'ix', params: {siteId: '1189869'}},
                                {bidder: 'mediapool', params: {mid: '2043489', priceType: 'net'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201021'}},
                                {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756170'}},
                                {bidder: "richaudience", params: {pid: "CHiOgMZAWq", supplyType: "site"}},
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719110}},
                                {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                                {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '125760'}},
                                {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                            ]
                        }
                    );
                                        
                }

    
            // **************** Branding_Left GPT and Prebid definition. *******************

            else if (el.id === 'Branding_Left') { // Check if Branding_Left div is present in body.

                if (adWindowWidth < 1600) {
                    return;
                }

                Branding_Left = googletag.defineSlot(adUnitPath + 'Branding_Left', [[120, 600], [160, 600]], 'Branding_Left')
                                    .defineSizeMapping(branding_mapping)
                                    .setTargeting('position', 'Branding_Left')
                                    .setTargeting('refresh_count', '0')
                                    .addService(googletag.pubads());

                adUnitsATF.push(
                    {   code: 'Branding_Left',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1600, 0], sizes: [[120, 600], [160, 600]] },
                            { minViewPort: [0, 0], sizes: [] }
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1332633'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '565243839'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '7599688'}},
                            {bidder: "richaudience", params: {pid: "ZsAGp67KGL", supplyType: "site"}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 4077093}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120622'}},
                            {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                        ]
                    }
                );

            }

            // **************** Branding_Right GPT and Prebid definition. *******************

            else if (el.id === 'Branding_Right') { // Check if Branding_Right div is present in body.

                if (adWindowWidth < 1600) {
                    return;
                }

                Branding_Right = googletag.defineSlot(adUnitPath + 'Branding_Right', [[120, 600], [160, 600]], 'Branding_Right')
                                     .defineSizeMapping(branding_mapping)
                                     .setTargeting('position', 'Branding_Right')
                                     .setTargeting('refresh_count', '0')
                                     .addService(googletag.pubads());

                adUnitsATF.push(
                    {   code: 'Branding_Right',
                        mediaTypes: {banner: {
                        sizeConfig: [
                            { minViewPort: [1600, 0], sizes: [[120, 600], [160, 600]] },
                            { minViewPort: [0, 0], sizes: [] }
                        ]
                        }},
                        bids: [
                            {bidder: 'criteo', params: {networkId: 9517}},
                            {bidder: "eskimi", params: {placementId: 3201}},
                            {bidder: 'ix', params: {siteId: '1332634'}},
                            {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '565243840'}},
                            {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '7599689'}},
                            {bidder: "richaudience", params: {pid: "1wszsYYfQ5", supplyType: "site"}},
                            {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 4077095}},
                            {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                            {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120623'}},
                            {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                        ]
                    }
                );

            }

            // **************** P1_Desktop GPT definition. *******************

                else if (el.id === 'P1_Desktop') { // Check if P1_Desktop div is present in body. 

                    // P1_Desktop ad unit definition
                    P1_Desktop = googletag.defineSlot(adUnitPath + 'P1', [[300, 250]], 'P1_Desktop')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P1')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P1_Desktop Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'P1_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            bids: [
                                {bidder: 'criteo', params: {networkId: 9517}},
                                {bidder: "eskimi", params: {placementId: 3201}},
                                {bidder: 'ix', params: {siteId: '1189870'}},
                                {bidder: 'mediapool', params: {mid: '2043488', priceType: 'net'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201023'}},
                                {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756173'}},
                                {bidder: "richaudience", params: {pid: "TgetLQKcra", supplyType: "site"}},
                                {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719112}},
                                {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120624'}},
                                {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                            ]
                        }
                    );

                }

                // **************** P2_Desktop GPT definition. *******************

                else if (el.id === 'P2_Desktop') { // Check if P2_Desktop div is present in body. 

                    // P2_Desktop ad unit definition
                    P2_Desktop = googletag.defineSlot(adUnitPath + 'P2', [[300, 250]], 'P2_Desktop')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P2')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P2_Desktop Prebid placement IDs to the ATF array.      
                    adUnitsBTF.push(
                        {   code: 'P2_Desktop',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[300, 250], [120, 600], [160, 600], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            bids: [
                                {bidder: 'criteo', params: {networkId: 9517}},
                                {bidder: "eskimi", params: {placementId: 3201}},
                                {bidder: 'ix', params: {siteId: '1189871'}},
                                {bidder: 'mediapool', params: {mid: '2043488', priceType: 'net'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201025'}},
                                {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756177'}},
                                {bidder: "richaudience", params: {pid: "mNGyqYWQnI", supplyType: "site"}},
                                {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719114}},
                                {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120625'}},
                                {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                            ]
                        }
                    );

                }

            }

            else {

                // **************** P1_Mobile GPT definition. *******************

                if (el.id === 'P1_Mobile') { // Check if P1_Mobile div is present in body. 

                    // P1_Mobile ad unit definition
                    P1_Mobile = googletag.defineSlot(adUnitPath + 'P1', [[300, 250]], 'P1_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P1')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P1_Mobile Prebid placement IDs to the ATF array.      
                    adUnitsATF.push(
                        {   code: 'P1_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[300, 250], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            bids: [
                                {bidder: 'criteo', params: {networkId: 9517}},
                                {bidder: "eskimi", params: {placementId: 3201}},
                                {bidder: 'ix', params: {siteId: '1189870'}},
                                {bidder: 'mediapool', params: {mid: '2043488', priceType: 'net'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201023'}},
                                {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756173'}},
                                {bidder: "richaudience", params: {pid: "TgetLQKcra", supplyType: "site"}},
                                {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719112}},
                                {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120624'}},
                                {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                            ]
                        }
                    );

                }

                // **************** P2_Mobile GPT definition. *******************

                else if (el.id === 'P2_Mobile') { // Check if P2_Mobile div is present in body. 

                    // P2_Mobile ad unit definition
                    P2_Mobile = googletag.defineSlot(adUnitPath + 'P2', [[300, 250]], 'P2_Mobile')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P2')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P2_Mobile Prebid placement IDs to the ATF array.      
                    adUnitsBTF.push(
                        {   code: 'P2_Mobile',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[300, 250], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            bids: [
                                {bidder: 'criteo', params: {networkId: 9517}},
                                {bidder: "eskimi", params: {placementId: 3201}},
                                {bidder: 'ix', params: {siteId: '1189871'}},
                                {bidder: 'mediapool', params: {mid: '2043488', priceType: 'net'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201025'}},
                                {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756177'}},
                                {bidder: "richaudience", params: {pid: "mNGyqYWQnI", supplyType: "site"}},
                                {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719114}},
                                {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120625'}},
                                {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                            ]
                        }
                    );

                }

                // **************** P3 GPT definition. *******************

                else if (el.id === 'P3') { // Check if P3 div is present in body. 

                    // P3 ad unit definition
                    P3 = googletag.defineSlot(adUnitPath + 'P3', [[300, 250]], 'P3')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P3')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P3 Prebid placement IDs to the ATF array.      
                    adUnitsBTF.push(
                        {   code: 'P3',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[300, 250], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            bids: [
                                {bidder: 'criteo', params: {networkId: 9517}},
                                {bidder: "eskimi", params: {placementId: 3201}},
                                {bidder: 'ix', params: {siteId: '1189872'}},
                                {bidder: 'mediapool', params: {mid: '2043488', priceType: 'net'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201028'}},
                                {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756180'}},
                                {bidder: "richaudience", params: {pid: "9FjSpUPMFD", supplyType: "site"}},
                                {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719116}},
                                {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '120626'}},
                                {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                            ]
                        }
                    );

                }    

                // **************** P4 GPT definition. *******************

                else if (el.id === 'P4') { // Check if P4 div is present in body. 

                    // P4 ad unit definition
                    P4 = googletag.defineSlot(adUnitPath + 'P4', [[300, 250]], 'P4')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P4')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P4 Prebid placement IDs to the ATF array.      
                    adUnitsBTF.push(
                        {   code: 'P4',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[300, 250], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            bids: [
                                {bidder: 'criteo', params: {networkId: 9517}},
                                {bidder: "eskimi", params: {placementId: 3201}},
                                {bidder: 'ix', params: {siteId: '1189873'}},
                                {bidder: 'mediapool', params: {mid: '2043488', priceType: 'net'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201030'}},
                                {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756184'}},
                                {bidder: "richaudience", params: {pid: "t2och9JsLg", supplyType: "site"}},
                                {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719118}},
                                {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '123584'}},
                                {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                            ]
                        }
                    );

                }   

                // **************** P5 GPT definition. *******************

                else if (el.id === 'P5') { // Check if P5 div is present in body. 

                    // P5 ad unit definition
                    P5 = googletag.defineSlot(adUnitPath + 'P5', [[300, 250]], 'P5')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P5')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P5 Prebid placement IDs to the ATF array.      
                    adUnitsBTF.push(
                        {   code: 'P5',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[300, 250], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            bids: [
                                {bidder: 'criteo', params: {networkId: 9517}},
                                {bidder: "eskimi", params: {placementId: 3201}},
                                {bidder: 'ix', params: {siteId: '1189874'}},
                                {bidder: 'mediapool', params: {mid: '2043488', priceType: 'net'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201032'}},
                                {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756187'}},
                                {bidder: "richaudience", params: {pid: "WTMlFeZgby", supplyType: "site"}},
                                {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719120}},
                                {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '125177'}},
                                {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                            ]
                        }
                    );

                }   

                // **************** P6 GPT definition. *******************

                else if (el.id === 'P6') { // Check if P6 div is present in body. 

                    // P6 ad unit definition
                    P6 = googletag.defineSlot(adUnitPath + 'P6', [[300, 250]], 'P6')
                                .defineSizeMapping(p_mapping)
                                .setTargeting('position', 'P6')
                                .setTargeting('refresh_count', '0')
                                .addService(googletag.pubads());

                    // Push the defined P6 Prebid placement IDs to the ATF array.      
                    adUnitsBTF.push(
                        {   code: 'P6',
                            mediaTypes: {banner: {
                            sizeConfig: [
                                { minViewPort: [1024, 0], sizes: [[300, 250], [300, 600]] }, //desktop
                                { minViewPort: [469, 0], sizes: [[300, 250], [336, 280]] }, //tablet
                                { minViewPort: [0, 0], sizes: [[300, 250], [336, 280]] }, //mobile
                            ]
                            }},
                            bids: [
                                {bidder: 'criteo', params: {networkId: 9517}},
                                {bidder: "eskimi", params: {placementId: 3201}},
                                {bidder: 'ix', params: {siteId: '1189875'}},
                                {bidder: 'mediapool', params: {mid: '2043488', priceType: 'net'}},
                                {bidder: 'openx', params: {delDomain: 'ringieraxelspr-d.openx.net', unit: '562201035'}},
                                {bidder: 'pubmatic', params: {publisherId: '158892', adSlot: '6756190'}},
                                {bidder: "richaudience", params: {pid: "maxcOIuPOL", supplyType: "site"}},
                                {bidder: "rtbhouse", params: {region: "prebid-eu", publisherId: "eq7oNcAuPBmB2fDVrcVE", bidfloor: 0.10}},
                                {bidder: 'magnite', params: {accountId: 19712, siteId: 583806, zoneId: 3719122}},
                                {bidder: 'smartadserver', params: {networkId: '4527', siteId: '695911', pageId: '2056975', formatId: '125178'}},
                                {bidder: 'teads', params: {pageId: 222369, placementId: 238989}},
                            ]
                        }
                    );
                            
                }   

            }

        }); // End of wrapperAd divs check. 

        //Create sticky ad once the ad is ready to render
        googletag.pubads().addEventListener('slotRenderEnded', function(event) {

            let unitPath = event.slot.getAdUnitPath(); //get the ad unith path for the slot which will render the ad
            let stickyBackground = document.getElementById('adhesion_background'); //get the adhesion background id
            //let windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth; //check user's screen width

            if (unitPath === adUnitPath + "Sticky" && event.isEmpty === true) {
                let sticky = document.getElementById('Adhesion');
                sticky.style.display = 'none';
            }

            // if ad unit is sticky and the background is not set, set sticky CSS for sticky ad unit
            else if (unitPath === adUnitPath + "Sticky" && stickyBackground === null){
            let sticky = document.getElementById('Adhesion');
            sticky.style.position = 'fixed';
            sticky.style.zIndex = '999999';
            sticky.style.width = '100%';
            sticky.style.height = '';
            sticky.style.bottom = '0px';
            sticky.style.textAlign = 'center';	
            sticky.style.padding = '10px 0px 0px';
            sticky.style.borderTop = '1px #CCC solid';
            
            // create adhesion background
            let background = document.createElement("div");
            background.setAttribute("ID", "adhesion_background");
            background.style.backgroundColor = '#FFF';
            
            if (adWindowWidth > 1024) {
                background.style.opacity = '70%';
            }

            else {
                background.style.opacity = '100%';
            }

            background.style.position = 'absolute';
            background.style.height = '100%';
            background.style.width = '100%';
            background.style.top = '0';
            background.style.left = '0';
            background.style.zIndex = '-1';
            sticky.appendChild(background);

            // create placeholder text
            /*let placeholder = document.createElement("div");
            placeholder.setAttribute("ID", "adText");
            placeholder.style.textAlign = 'center';
            placeholder.style.fontSize = '10px';
            placeholder.style.color = '#CCC';
            placeholder.style.height = '20px';
            placeholder.style.borderTop = '1px #CCC solid';
            placeholder.style.paddingTop = '2px';
            placeholder.textContent = 'Oglas'
            background.appendChild(placeholder);*/
        
            // create close button with svg elements
            let closeButton = document.createElement("div");
            closeButton.setAttribute("ID", "close_adhesion")
            closeButton.style.position = 'absolute';
            closeButton.style.top = '-29px';
            closeButton.style.right = '0px';
            closeButton.style.cursor = 'pointer';
            closeButton.style.padding = '8px';
            //closeButton.style.borderRadius = '50%';
            closeButton.style.border = '1px solid #CCC';
            //closeButton.style.boxShadow = '0 0 3px #b8b9be';
            closeButton.style.background = '#FFF';
            closeButton.style.borderBottom = '1px solid #FFF';
            closeButton.style.borderTopLeftRadius = '10px';
            
            let iconSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
            let iconPath = document.createElementNS(
                'http://www.w3.org/2000/svg',
                'path'
            );

            iconSvg.setAttribute('display', 'block');
            iconSvg.setAttribute('fill', '#000');
            iconSvg.setAttribute('width', '12px');
            iconSvg.setAttribute('height', '12px');
            iconSvg.setAttribute('viewBox', '0 0 8 8');

            iconPath.setAttribute(
                'd',
                'M1.41 0l-1.41 1.41.72.72 1.78 1.81-1.78 1.78-.72.69 1.41 1.44.72-.72 1.81-1.81 1.78 1.81.69.72 1.44-1.44-.72-.69-1.81-1.78 1.81-1.81.72-.72-1.44-1.41-.69.72-1.78 1.78-1.81-1.78-.72-.72z'
            );
            
            iconSvg.appendChild(iconPath);
            closeButton.appendChild(iconSvg); 
            sticky.appendChild(closeButton);
            
            // when user clicks the close button, remove the sticky div
            document.getElementById("close_adhesion").addEventListener('click', function(e) {
                e.preventDefault();
                sticky.parentNode.removeChild(sticky);
            }, false); 


            } 
        });        
        
        // Check if adsKeywords object is present
        if (typeof adsKeywords != 'undefined') {

            // Check if adsKeywords attributes are present, if so, pass them as key values to GAM
            if (typeof adsKeywords.category != 'undefined') {
                googletag.pubads().setTargeting('category', adsKeywords.category);
            } 

            if (typeof adsKeywords.subcategory != 'undefined') {
                googletag.pubads().setTargeting('subcategory', adsKeywords.subcategory);
            } 

            if (typeof adsKeywords.pageType != 'undefined') {
                googletag.pubads().setTargeting('pageType', adsKeywords.pageType);
            } 

            if (typeof adsKeywords.articleId != 'undefined') {
                googletag.pubads().setTargeting('articleId', [adsKeywords.articleId].join(','));
            } 
            
            if (typeof adsKeywords.articleTags != 'undefined') {
                googletag.pubads().setTargeting('articleTags', [adsKeywords.articleTags].join(','));
            } 
        }

        let adQueryString = window.location.search; // Get the whole string in the URL. 
        //console.log("Query string is " + adQueryString);

        let adUrlParams = new URLSearchParams(adQueryString); // Get the information after ? in the URL. 
        //console.log("URL param is " +  adUrlParams);

        if (adUrlParams.has('adTest')) { 
            let adValue = adUrlParams.get('adTest'); // If there is a adTest param get the value after =. 
            //console.log("AdTest value is " + adValue);
            googletag.pubads().setTargeting('adTest', adValue); // Send the adTest value to GAM.
        } 

        googletag.pubads().disableInitialLoad(); // Disables requests for ads on page load. 
        googletag.pubads().enableSingleRequest(); // Enables single request mode for fetching multiple ads at the same time.
        googletag.pubads().setCentering(true);
        googletag.enableServices(); // Enables all GPT services that have been defined for ad slots on the page.

        // Get the list of slots associated with this service.
        googletag.pubads().getSlots().forEach(function(adSlots) {
            googletag.display(adSlots.getSlotElementId()); // Instructs slot services to render all of the defined ad slots. 
        });

        atfSlotsToRefresh = [Adhesion, Billboard, P1_Desktop, P1_Mobile, In_Text_1];

        if (adWindowWidth >= 1024) {
            if (typeof Branding_Left !== 'undefined' && Branding_Left) {
                atfSlotsToRefresh.push(Branding_Left);
            }
            if (typeof Branding_Right !== 'undefined' && Branding_Right) {
                atfSlotsToRefresh.push(Branding_Right);
            }
        }

        // Do not refresh ATF here. The initial ATF request is sent once from initAdserver()
        // after Prebid targeting is available. Refreshing here and again in initAdserver()
        // caused duplicate first-load ad requests.

    });


    pbjs.que.push(function() {

        pbjs.aliasBidder('adform', 'mediapool', {gvlid:50});
    
        pbjs.setConfig({
    
            priceGranularity: 'high', //$0.01 increments, up to $20

            storageControl: {
                enforcement: 'off'
            },

            enableSendAllBids: false, //send only top bids
            targetingControls: {
              alwaysIncludeDeals: true //send all deal bids
            },
    
            //Currency module
            currency: {
                "adServerCurrency": "EUR",
                "conversionRateFile": "https://cdn.jsdelivr.net/gh/prebid/currency-file@1/latest.json",
             },
    
            //Coockie match and user syncs
            userSync: {
                syncEnabled: true,
                syncsPerBidder: 5,
                syncDelay: 3000,
                auctionDelay: 50,
                userIds: [
    
                    { name: "sharedId", 
                      storage: { type: "cookie", name: "_sharedid", expires: 365 } 
                    },
    
                    { name: "id5Id",
                        params: { partner: 1355, externalModuleUrl: 'https://cdn.id5-sync.com/api/1.0/id5PrebidModule.js' },
                        storage: { type: "html5", name: "id5id", expires: 90, refreshInSeconds: 8*3600 }
                    },
    
                    { name: 'teadsId',
                      params: { pubId: 26849 }
                    },
    
                    { name: 'criteo',
                    },
    
                    { name: 'lotamePanoramaId',
                    },
    
                ],
                aliasSyncEnabled: true,
                filterSettings: { all: { bidders: "*", filter: "include" } },
            },

            enableTIDs: true,

            // defaultGdprScope is deliberately false: if the CMP never answers
            // (and even the TCF watchdog at the top of this file somehow fails
            // to take over), Prebid proceeds after the timeout treating GDPR as
            // not applying, which is the correct resolution for this site's
            // non-EEA (Serbian) audience. With defaultGdprScope true, a stuck
            // CMP means "GDPR applies with zero consent" and every auction
            // dies — that is exactly the failure mode that took the site's ads
            // down on 03.09.2026.
            consentManagement: {
                gdpr: {
                  cmpApi: 'iab',
                  timeout: 8000,
                  defaultGdprScope: false
                }
            }, 

            schain: {
                validation: "strict",
                config: {
                  ver:"1.0",
                  complete: 1,
                  nodes: [
                    {
                      asi:"ringier.rs",
                      sid:"20221205191916",
                      hp:1
                    }
                  ]
                }
            },

            gptPreAuction: {
                enabled: true,
                mcmEnabled: true
            }

        });

        pbjs.bidderSettings = {
            standard: {
                storageAllowed: true,
            },
        };      
        
        //Add only ATF ad units.
        pbjs.addAdUnits(adUnitsATF);
        
        //Request bids.
        pbjs.requestBids({
            bidsBackHandler: initAdserver,
            timeout: PREBID_TIMEOUT
        });
    });

    // Send requests to the SSPs and send bids to GAM for the ATF slots.
    function initAdserver() {
        if (pbjs.initAdserverSet) return;
        pbjs.initAdserverSet = true;
        googletag.cmd.push(function() {
            pbjs.que.push(function() {
                pbjs.setTargetingForGPTAsync();
                googletag.pubads().refresh(atfSlotsToRefresh.filter(Boolean));
            });
        });
    };

    //Add BTF ad units.
    pbjs.que.push(function() {
        pbjs.addAdUnits(adUnitsBTF);
    });


    // Use IntersectionObserver API to check whether an ad slot is at the certain distance. 
    var observer = new IntersectionObserver (function(entries) {

        entries.forEach(entry => {

            if (entry.isIntersecting) {

                let adSlot = entry.target.id; // Get the div id of the slot being observed. 

                // Request bids and push the ads to GAM. 
                pbjs.que.push(function() {
                    pbjs.requestBids({
                        timeout: PREBID_TIMEOUT,
                        adUnitCodes: [adSlot],
                        bidsBackHandler: function() {
                            pbjs.setTargetingForGPTAsync([adSlot]);

                            // If div with the certain ID is present and observed, refresh GAM slot.
                            if (adWindowWidth >= 1024) {

                                if (adSlot === 'P2_Desktop') {
                                    googletag.pubads().refresh([P2_Desktop]); 
                                } 

                                else if (adSlot === 'Billboard_2') {
                                    googletag.pubads().refresh([Billboard_2]); 
                                } 

                                else if (adSlot === 'Billboard_3') {
                                    googletag.pubads().refresh([Billboard_3]); 
                                } 

                                else if (adSlot === 'Billboard_4') {
                                    googletag.pubads().refresh([Billboard_4]); 
                                } 

                                else if (adSlot === 'In_Text_2') {
                                    googletag.pubads().refresh([In_Text_2]); 
                                } 

                                else if (adSlot === 'In_Text_3') {
                                    googletag.pubads().refresh([In_Text_3]); 
                                } 

                                else if (adSlot === 'In_Text_4') {
                                    googletag.pubads().refresh([In_Text_4]); 
                                } 

                                else if (adSlot === 'In_Text_5') {
                                    googletag.pubads().refresh([In_Text_5]); 
                                } 

                                else if (adSlot === 'In_Text_6') {
                                    googletag.pubads().refresh([In_Text_6]); 
                                } 

                                else if (adSlot === 'In_Text_7') {
                                    googletag.pubads().refresh([In_Text_7]); 
                                } 

                                else if (adSlot === 'In_Text_8') {
                                    googletag.pubads().refresh([In_Text_8]); 
                                } 

                                else if (adSlot === 'In_Text_9') {
                                    googletag.pubads().refresh([In_Text_9]); 
                                } 

                                else if (adSlot === 'In_Text_10') {
                                    googletag.pubads().refresh([In_Text_10]); 
                                } 

                            }

                            else {

                                if (adSlot === 'P2_Mobile') {
                                    googletag.pubads().refresh([P2_Mobile]); 
                                } 

                                else if (adSlot === 'P3') {
                                    googletag.pubads().refresh([P3]); 
                                } 

                                else if (adSlot === 'P4') {
                                    googletag.pubads().refresh([P4]); 
                                } 

                                else if (adSlot === 'P5') {
                                    googletag.pubads().refresh([P5]); 
                                } 

                                else if (adSlot === 'P6') {
                                    googletag.pubads().refresh([P6]); 
                                } 

                                else if (adSlot === 'In_Text_2') {
                                    googletag.pubads().refresh([In_Text_2]); 
                                } 

                                else if (adSlot === 'In_Text_3') {
                                    googletag.pubads().refresh([In_Text_3]); 
                                } 

                                else if (adSlot === 'In_Text_4') {
                                    googletag.pubads().refresh([In_Text_4]); 
                                } 

                                else if (adSlot === 'In_Text_5') {
                                    googletag.pubads().refresh([In_Text_5]); 
                                } 
                                
                                else if (adSlot === 'In_Text_6') {
                                    googletag.pubads().refresh([In_Text_6]); 
                                } 

                                else if (adSlot === 'In_Text_7') {
                                    googletag.pubads().refresh([In_Text_7]); 
                                } 

                                else if (adSlot === 'In_Text_8') {
                                    googletag.pubads().refresh([In_Text_8]); 
                                } 

                                else if (adSlot === 'In_Text_9') {
                                    googletag.pubads().refresh([In_Text_9]); 
                                } 

                                else if (adSlot === 'In_Text_10') {
                                    googletag.pubads().refresh([In_Text_10]); 
                                } 

                            }

                        }
                    });
                });

                observer.unobserve(entry.target); // Stop observing the ad slot which has alredy been seen. 
            }
        })
    }, {rootMargin: DISTANCE_IN_PIXELS_FOR_LAZY_LOADING}); // Distance to the ad slot.

    document.querySelectorAll('.lazyAd').forEach(slots => { observer.observe(slots) }); // Check all divs with the class lazyAd and observe them all. 

    // Get the list of slots associated with this service for the refresh logic.
    googletag.pubads().getSlots().forEach(function(slotAd) {

        var divId = slotAd.getSlotElementId(); // Get the ID of the ad slot in question.
        let param = slotAd.getTargeting('refresh_count'); // get the ad slot's refresh_count value (it should be 0 at the start)
        let interval;

        // Use IntersectionObserver API to check whether an ad slot is viewable for certain percent. 
        var viewabilityObserver = new IntersectionObserver (function(viewabilityEntries) {

            viewabilityEntries.forEach(viewabilityEntry => {

                let slotId = viewabilityEntry.target.id; // Get the ID of the div ID which is being observed.

                if (viewabilityEntry.isIntersecting) {

                    interval = setInterval(function () {

                        let advertiserID;

                        try {
                            advertiserID = slotAd.getResponseInformation().advertiserId; // Get the order ID of the in view creative.
                          }
                        
                        catch(err) {
                            //console.log("Advertiser ID is not defined for slot " + divId);
                        }

                        if (!GAM_NOREFRESH_ADVERTISER_IDS.includes(advertiserID) && !GAM_NOREFRESH_ADUNITS.includes(divId) && document.visibilityState === "visible") { // If order ID is not included in the GAM_NOREFRESH_ORDER_IDS array and div ID is not included in GAM_NOREFRESH_ADUNITS, do refresh.

                            pbjs.requestBids({ // Request bids from Prebid partners.
                                timeout: PREBID_TIMEOUT,
                                adUnitCodes: [slotId],
                                bidsBackHandler: function() {
                                    pbjs.setTargetingForGPTAsync([slotId]);
                                    googletag.pubads().refresh([slotAd]); // Refresh GAM ad slots.
                                    param++; // Increase the param by 1. 
                                    slotAd.setTargeting('refresh_count', param); // Set the new param as a key value.
                                }
                            });

                        }

                    }, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
                }
 
                else {
                    clearInterval(interval); // If the slot is not intersecting, remove the interval.
                }
            })

        }, {threshold: VISIBILITY_PERCENT_FOR_REFRESH}); // Percent of the ad slot that has to be viewable to start refresh.

            document.querySelectorAll('#' + divId).forEach(viewabilitySlots => { viewabilityObserver.observe(viewabilitySlots) }); // Observe all divs which are present on the page. 
        
    });

}
